<template lang="pug">
  .fkko-table
    .content
      .e-table.table
        .table-head.table__head
          .table__row
            .table__col.table__head.semibold(v-for="item in visibleColumns")
              .d-flex.align-items-center.table__headname
                .sortable
                  .text.sortable__text(:click.prevent="letSort(item)") {{meta.fields[item].label }}
                  .sortable__arrows(v-if="meta.sort.name !=='code'")
                    button.reset-btn.button.button_no-border.button_icon.button_arrow.sortable__up(:class="meta.sort[item] === 'asc' ? 'active' : ''")
                    button.reset-btn.button.button_no-border.button_icon.button_arrow.sortable__down(:class="meta.sort[item] === 'desc' ? 'active' : ''")
          div
        e-perfect-scrollbar(
          :styles="calcMaxHeight"
          :config="{suppressScrollY: false, suppressScrollX: false}"
          class="real-table-scrollbar"
        )
          .e-table__body-wrapper.table__body-wrapper
            .table-body.table__body(v-if="values.length")
              expand-row(
                v-for="(value) in values"
                :value="value"
                :visibleColumns="visibleColumns"
                :key="value.id"
                :depth="0"
                @delete="onDelete"
              )
            div(v-else).table-body.table__body
              div.item
                div Ничего не найдено
                div
</template>

<script>
import expandRow from './fkko-row'

export default {
  name: 'fkko-table',
  components: {
    expandRow,
  },
  props: {
    items: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentSort: '',
    }
  },
  computed: {
    calcMaxHeight() {
      return { height: window.innerHeight - 310 + 'px' }
    },
    values() {
      this.items.data.forEach((el) => {
        let res = el.code
        el.codeNumber = +res.replace(/\s+/g, '')
      })
      this.items.data = this.items.data.sort((a, b) =>
        a.codeNumber > b.codeNumber ? 1 : -1
      )
      return this.items.data
    },
    meta() {
      this.items._meta.fields.code.sortable = false
      this.items._meta.fields.name.sortable = false
      this.items._meta.sort.id = 'code'
      this.items._meta.sort.name = 'code'
      return this.items._meta
    },
    // all fields visible
    visibleColumns() {
      let columnsarr = []
      for (let fName in this.meta.fields) {
        columnsarr.push(fName)
      }
      return columnsarr
    },
  },
  methods: {
    onDelete(value) {
      this.$emit('delete', value)
    },
    letSort() {
      console.warn('Please, describe action')
    },
  },
}
</script>
